import React from 'react';
import { LuChevronRight } from 'react-icons/lu';
import { cx } from '../../../utils/cx.js';
import { FOCUS_RING } from '../../ui/Button';

const Breadcrumb = ({ items }) => (
  <nav aria-label="Fil d'Ariane" className="flex flex-wrap items-center gap-1.5 text-sm">
    {items.map((item, i) => (
      <React.Fragment key={item.label}>
        {i > 0 && <LuChevronRight className="h-3.5 w-3.5 text-gray-300 dark:text-gray-600" aria-hidden />}
        {item.onClick
          ? <button type="button" onClick={item.onClick} className={cx('rounded font-medium text-brand-600 hover:underline dark:text-brand-400', FOCUS_RING)}>{item.label}</button>
          : <span className="font-semibold text-gray-900 dark:text-white" aria-current="page">{item.label}</span>}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumb;
